"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FocusEventPolyfill = function (eventType, params) {
    if (params === void 0) { params = {}; }
    var inputEvent = document.createEvent('UIEvent');
    // prettier-ignore
    inputEvent.initEvent(eventType, params.bubbles || true, params.cancelable || true);
    return inputEvent;
};
exports.default = FocusEventPolyfill;
//# sourceMappingURL=focus-event.js.map